var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_vm._t("default"),_c('app-loading',{attrs:{"show":_vm.showLoading}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }